import { extendTheme } from '@chakra-ui/react';

export const chakraTheme = extendTheme({
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },
  zIndices: {
    hide: -1,
    auto: 'auto',
    base: 0,
    toast: 5000,
  },
});
